import type { AvatarStyleTypes } from '@material-tailwind/react';

const styles: AvatarStyleTypes = {
  defaultProps: {
    variant: 'rounded',
  },
  styles: {
    base: {
      initial: { colors: 'bg-gray-100' },
    },
    variants: {
      circular: {
        border: 'rounded-full',
      },
      square: { border: 'rounded-none' },
      rounded: { border: 'rounded-lg' },
    },
  },
};

export default styles;
